import React, { Component } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

const isTextTruncated = (element) => {
	if (element) {
		return element.scrollWidth > 150;
	}
	return false;
};

class CheckboxInput extends Component {
	constructor(props) {
		super(props);

		this.state = {
			eyebrowEnable: false,
			showTooltip: false
		};
		this.labelRef = React.createRef();
		this.uniqueId = 'id-' + Math.random().toString(36).substring(2, 9);
	}
	onMouseEnter = () => {
		this.setState({ eyebrowEnable: true })
		if (this.labelRef.current && isTextTruncated(this.labelRef.current)) {
			this.setState({ showTooltip: true });
		}
	}
	onMouseLeave = () => {
		this.setState({ eyebrowEnable: false, showTooltip: false });
	}
	render() {
		const { key, label, onClick, checked, classes, unsetHeight, eyebrow, left, style, disableHover, disabled } = this.props;
		const { eyebrowEnable } = this.state;
		const cleanId = this.props.id ? this.props.id.replace(/[^a-zA-Z0-9-_]/g, '-') : this.uniqueId;
		const labelId = `id-${cleanId}`;
		return (
			<div
				style={style ? style : {}}
				onMouseLeave={eyebrow && this.onMouseLeave}
				onMouseEnter={eyebrow && this.onMouseEnter}
				key={`colToggle-${key}`}
				className={`checkboxInput ${disableHover ? 'disableHover' : ''} ${classes ? classes : ''} ${eyebrowEnable ? 'eyebrowEnabledContainer' : 'eyebrowDisabledContainer'}`}
				onClick={!disabled && onClick}
			>
				{left &&
					<div className={`checkBox mr-10 ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
						<i className="las la-check" />
					</div>}
				<div>
					{eyebrow && <p className={` ${eyebrowEnable ? ' small eyebrowEnabled ' : 'eyebrowDisabled'}`}
					>
						{eyebrowEnable && eyebrow}
					</p>}
					<p className='mb-0 checkBoxInput-truncate' ref={this.labelRef} id={labelId}>
						{label}
					</p>
					{this.state.showTooltip && this.labelRef?.current && (
						<UncontrolledTooltip
							placement="top"
							target={labelId}
							delay={{ show: 100, hide: 0 }}
						>
							{label}
						</UncontrolledTooltip>
					)}
				</div>
				{!left && <div className={`checkBox ml-a ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
					<i className="las la-check" />
				</div>}
			</div>
		);
	}
}

export default CheckboxInput;
